module.exports = __webpack_public_path__ + "bd69382325fcd9a77b207e98a314c223.ttf";